import { useEffect, useState } from 'react'

export function SensitiveDataMode() {
  const [isInScreenshotMode, setIsInDataSensitiveMode] = useState(false)

  const handleKeyDown = (event: KeyboardEvent) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 'i') {
      toggleDataSensitiveMode()
    }
  }

  const toggleDataSensitiveMode = () => {
    document.body.classList.toggle('sensitive', !isInScreenshotMode)
    setIsInDataSensitiveMode((current) => !current)
  }

  useEffect(() => {
    // Listen for key events
    window.addEventListener('keydown', handleKeyDown)

    // Remove listener when component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  })

  //Reset to false when changing to different url/window
  useEffect(() => {
    setIsInDataSensitiveMode(false)
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href])

  return null
}
